module.exports = __webpack_public_path__ + "static/media/image_1-min.c8dbfa02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/image_1-min.jpg
// module id = 1080
// module chunks = 0